import gsap from "gsap";
import DefaultBlock from "/scripts/default/block";
import { watchPreferredMotion } from "../../../../../utils/helpers/watchPreferredMotion";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import debounce from "lodash.debounce";

gsap.registerPlugin(ScrollTrigger);

export default class UICursor extends DefaultBlock {
	init() {
		this.DOM = {
			wrapper: document.getElementById("ui-demo-cursor"),
			cursor: this.block.querySelector("#ui-cursor"),
		};

		this.getDimensions();

		this.xOffset = 1.1;
		this.yOffset = 0.3;
		this.xTo = gsap.quickTo(this.DOM.cursor, "x", {
			duration: 0.1,
			ease: "power2",
		});
		this.yTo = gsap.quickTo(this.DOM.cursor, "y", {
			duration: 0.1,
			ease: "power2",
		});

		this.buildOn();
	}

	handleMouseMove(e) {
		this.xTo(e.clientX - this.wrapperRect.left);
		this.yTo(e.clientY - this.DOM.wrapper.getBoundingClientRect().top);
	}

	initEvents() {
		window.addEventListener(
			"resize",
			debounce(() => this.getDimensions(), 200)
		);

		this.block.addEventListener("mouseenter", () => {
			if (this.leaveTween) {
				this.leaveTween.pause();
			}
		});
		this.block.addEventListener("mousemove", this.handleMouseMove.bind(this));
		this.block.addEventListener("mouseleave", () => {
			this.xTo.tween.pause();
			this.yTo.tween.pause();
			this.xTo.tween.invalidate();
			this.yTo.tween.invalidate();

			this.leaveTween = gsap.to(this.DOM.cursor, {
				x: this.xCenter,
				y: this.yCenter,
				duration: 0.5,
				ease: "power3.out",
			});
		});
	}

	getDimensions() {
		this.wrapperRect = this.DOM.wrapper.getBoundingClientRect();
		this.xCenter = this.wrapperRect.width / 2 - this.DOM.cursor.clientWidth / 2;
		this.yCenter =
			this.wrapperRect.height / 2 - this.DOM.cursor.clientHeight / 2;
	}

	buildOn() {
		gsap.set(this.block, { autoAlpha: 1 });

		watchPreferredMotion(() => {
			gsap
				.timeline({
					id: "ui-cursor-buildon",
					scrollTrigger: {
						trigger: this.DOM.wrapper,
						start: "top 60%",
					},
				})
				.fromTo(
					this.DOM.cursor,
					{
						x: this.wrapperRect.width,
						y: this.wrapperRect.height * 1.3,
						transformOrigin: "50% 50%",
					},
					{
						x: this.xCenter,
						y: this.yCenter,
						duration: 0.4,
						ease: "power3.out",
					}
				);
		});
	}
}
